import React, { Dispatch, SyntheticEvent, useState } from 'react';

import { ListItemText, Menu, MenuItem, SvgIcon } from '@material-ui/core';

import { down } from '../../../assets/icons';
import { AsaphButton } from '../Button';
import styles from './AsaphSelect.module.scss';

export interface AsaphSelectProps {
	value: string;
	setValue: Dispatch<string>;
	options: { value: string; label: string }[];
	className?: string;
}

export const AsaphSelect = ({
	value,
	setValue,
	options,
	className,
}: AsaphSelectProps) => {
	const [anchorEl, setAnchorEl] = useState<Element | null>(null);
	const open = Boolean(anchorEl);
	const handleOpen = (e: SyntheticEvent) => {
		setAnchorEl(e.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const label = options.find((option) => option.value === value)?.label;

	return (
		<div className={className}>
			<AsaphButton
				color="blue"
				label={label}
				onClick={handleOpen}
				endIcon={
					<SvgIcon
						component={down}
						classes={{
							root: open
								? styles['asaph-select__button-icon--open']
								: '',
						}}
					/>
				}
				fullWidth
				className={styles['asaph-select__button']}
			/>
			<Menu
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				open={open}
				onClose={handleClose}
				classes={{
					paper: styles['asaph-select__paper'],
					list: styles['asaph-select__list'],
				}}
			>
				{options.map((option) => (
					<MenuItem
						key={option.value}
						onClick={() => {
							setValue(option.value);
							handleClose();
						}}
						classes={{
							root: styles['asaph-select__list-item'],
						}}
					>
						<ListItemText>{option.label}</ListItemText>
					</MenuItem>
				))}
			</Menu>
		</div>
	);
};
